<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="609"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Subgroup Selection
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <div class="px-12 pt-4 my-5 text-center">
                <p class="body-1 px-10">
                  How many subgroup(s) do you want to divide selected animals,
                  based on nutrition requirement
                </p>

                <v-btn-toggle color="green">
                  <v-btn value="1" @click="getSubgroupValue(1)"> 1 </v-btn>
                  <v-btn value="2" @click="getSubgroupValue(2)"> 2 </v-btn>
                  <v-btn value="3" @click="getSubgroupValue(3)"> 3 </v-btn>
                </v-btn-toggle>
              </div>
            </v-card-text>
            <v-card-actions class="px-4 pb-5 justify-space-between">
              <v-btn
                @click="closeModal"
                outlined
                class="mr-2 px-5"
                right
                height="44"
                depressed
                color="primary"
                style="font-weight: 600"
              >
                Ignore
              </v-btn>
              <v-btn
                depressed
                height="44"
                color="primary"
                class="px-5"
                style="font-weight: 600"
                @click="createSubGroup"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      subGroupCount: 0,
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },

  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    selectedGroup: {
      type: Object,
      required: true,
    },
  },
  methods: {
    individualAnimal() {
      this.$router.push = "/feed-management/individual-animal";
    },
    closeModal() {
      this.$emit("closeDialog");
    },
    getSubgroupValue(value) {
      this.subGroupCount = Number(value);
    },
    createSubGroup() {
      if (this.subGroupCount > this.selectedGroup.animalCounts) {
        this.$notify({
          title: "Error!!!",
          text: "Sub Group is greater than animal count!!",
          type: "error",
        });

        return;
      }
      const data = {
        groupId: Number(this.selectedGroup.id),
        subGroupsCount: this.subGroupCount,
      };
      this.$emit("updateSubGroup", data);
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle {
  color: #00c26b;
}
.v-btn-toggle > .v-btn.v-btn--active {
  color: white !important;
  background: #00c26b;
}
::v-deep .v-btn-toggle .v-btn__content {
  padding: 0 8px !important;
  flex: inherit !important;
}
.v-btn-toggle > .v-btn.v-btn--active::after {
  display: contents;
  font-family: "Material Design Icons";
  content: "\F012C";
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 4em;
  width: 8em;
  color: #00c26b;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #00c26b !important;
}
</style>
